module.exports = __webpack_public_path__ + "static/media/w-2_18.dc96870a.png";